import { Input as AntInput, InputProps } from "@basic-components";

export interface InputPropsWithLabel extends InputProps {
  label?: string;
  isView?: boolean;
}
export const Input = ({ label = '', isView, value, ...rest }: InputPropsWithLabel) => {

  if (isView) return value || '--';

  return <AntInput placeholder={`请输入${label}`} value={value} {...rest} />;
};